import type { JSX } from 'react';
import './field-error.css';

export interface FieldErrorObject {
  message?: string;
}

export interface FieldErrorProps {
  /** react-hook-form FieldError object. Renders nothing when undefined or no message. */
  error?: FieldErrorObject | undefined;
  /** Stable HTML id shared with the input's aria-describedby. */
  id: string;
  /** data-testid value for Playwright selectors. Defaults to id with "-error" suffix. */
  testId?: string;
}

export function FieldError({ error, id, testId }: FieldErrorProps): JSX.Element | null {
  if (!error || !error.message) {
    return null;
  }
  const resolvedTestId = testId ?? (id.endsWith('-error') ? id : `${id}-error`);
  return (
    <p
      role="alert"
      id={id}
      className="field-error"
      data-testid={resolvedTestId}
      aria-live="polite"
    >
      {error.message}
    </p>
  );
}

export default FieldError;
